import { render } from "./BaseLayout.vue?vue&type=template&id=d15e3f96&scoped=true"
import script from "./BaseLayout.vue?vue&type=script&lang=js"
export * from "./BaseLayout.vue?vue&type=script&lang=js"

import "./BaseLayout.vue?vue&type=style&index=0&id=d15e3f96&scoped=true&lang=css"

import exportComponent from "/var/www/html/pk_wallet/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d15e3f96"]])

export default __exports__